<div>
  @if (fieldConfig && (!editMode || (editMode && !fieldConfig.editReadOnly))) {
    <mat-form-field>
      <mat-chip-set #chipList aria-label="Fruit selection">
        @for (item of list; track item; let i = $index) {
          <mat-chip [removable]="editMode" (removed)="remove(item, i)">
            {{ extractLabel(item) }}
            @if (editMode) {
              <mat-icon matChipRemove>cancel</mat-icon>
            }
          </mat-chip>
        }
      </mat-chip-set>
      <input [hidden]="true" matInput class="lookup-input" [errorStateMatcher]="matcher" />
      @if (editMode) {
        <mat-icon matSuffix class="edit-icon" matTooltip="Select" (click)="openModal()">mode_edit</mat-icon>
      }
    </mat-form-field>
  }
</div>
